import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustomerService, SrCustomerEditGet } from '@app/services/customer.service';
import { PostPlaceItem, TypeaheadService } from '@app/services/typeahead.service';

@Component({ selector: 'tt-sr-customer-edit', templateUrl: './sr-customer-edit.component.html', styleUrls: ['./sr-customer-edit.component.css'], standalone: false })
export class SrCustomerEditComponent implements OnInit {
    public page?: SrCustomerEditGet;
    public saving = false;
    public calculating = false;
    public error = '';
    private postplaces: PostPlaceItem[] = [];
    constructor(private readonly customer: CustomerService, private readonly typeahead: TypeaheadService, private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator) { this.navigator = useNavigatorFor(navigator, this); }
    public async ngOnInit(): Promise<void> { try { this.page = await this.customer.getSrCustomer({ cust_no: String(this.navigator?.params['cust_no'] ?? '') }); } catch (error) { this.showError(error); } }
    public searchPostplaces = async (params?: { value?: string }): Promise<PostPlaceItem[]> => {
        this.postplaces = await this.typeahead.searchPostplaces({ searchtext: params?.value ?? this.page?.postplace_name_street ?? '' });
        return this.postplaces;
    };
    public onPostplaceTextChanged(value: string): void {
        if (!this.page) return;
        const previous = this.page.postplace_name_street;
        this.page.postplace_name_street = value;
        if (previous === undefined || previous === value) return;
        if (value === '') this.page.postplace_id_street = '';
        else this.postplaces.forEach(item => { if (item.item_name === value && this.page) this.page.postplace_id_street = item.item_id; });
    }
    public selectPostplace(item?: PostPlaceItem): void {
        if (!this.page) return;
        this.page.postplace_name_street = item?.item_name ?? '';
        this.page.postplace_id_street = item?.item_id ?? '';
    }
    public async calculateBankaccount(): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try { const value: unknown = await this.modal.showCalculator('bankaccount', undefined, this.page.bankaccount); if (typeof value === 'string' || typeof value === 'number') this.page.bankaccount = value; }
        catch (error) { this.showError(error); } finally { this.calculating = false; }
    }
    public async save(): Promise<void> {
        if (!this.page || this.saving) return;
        this.saving = true;
        try { const response = await this.customer.saveSrCustomer(this.page); if (response.errorcode !== '0') await this.modal.show({ type: 'warning', title: 'Varsel', message: response.errormessage, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] }); else this.navigator?.back(); }
        catch (error) { this.showError(error); } finally { this.saving = false; }
    }
    private showError(error: unknown): void { this.error = error instanceof Error ? error.message : String(error); }
}
